import React, { useImperativeHandle, useMemo, useRef } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { COLORS } from '../../../constants/colors';
import { Header } from '../Header/Header';
import { LinearGradientBackground } from '../LinearGradientBackground';
import { ComponentWrapperProps } from './ComponentWrapperUtils';

const ComponentWrapper = (props: ComponentWrapperProps) => {
    const { disableLinearGradient = false } = props;
    const scrollRef = useRef<ScrollView>(null);

    useImperativeHandle(props.MB_Ref, () => ({
        scrollTo: ({ x, y, animated }) => {
            if (!scrollRef.current) {
                console.warn('Warning: ScrollRef was not set. Was wrapInScrollView set to false?');
                return;
            }
            scrollRef.current.scrollTo({ x, y, animated });
        },
    }));

    const content = useMemo(() => {
        return (
            <>
                {!disableLinearGradient && <LinearGradientBackground />}

                <View style={[styles.innerContainer, props.innerContainerStyle]} onLayout={props.onInnerComponentLayout}>

                    {!props.hideWebHeader &&
                        <Header containerStyle={{ marginHorizontal: -54 }}>
                            {props.headerChildren}
                        </Header>
                    }

                    {props.children}
                </View>
            </>
        );
    }, [disableLinearGradient, props]);

    if (props.wrapInScrollView) {
        return (
            <ScrollView
                ref={scrollRef}
                onLayout={props.onLayout}
                onScroll={props.onScroll}
                style={props.scrollViewStyle}
                scrollEventThrottle={64}
                contentContainerStyle={[styles.container, props.containerStyle]}
                keyboardShouldPersistTaps={props.keyboardShouldPersistTapsForScrollView}
            >
                {content}
            </ScrollView>
        );
    }

    return (
        <View style={[styles.container, props.containerStyle]} onLayout={props.onLayout}>
            {content}
        </View>
    );
};

export { ComponentWrapper };

const styles = StyleSheet.create({
    container: {
        minHeight: '100%',
        backgroundColor: COLORS.backgroundDarkPurple,
        justifyContent: 'space-between',
    },
    innerContainer: {
        maxWidth: 1680,
        paddingHorizontal: 54,
        alignSelf: 'center',
        width: '100%',
    },
});
